<div class="order-details-container">
  <div class="page-header-container">
    <div class="header-composed">
      <a (click)="navigateBack()" class="text-title-2 back-ref">
        {{(navigationState | navigatedFrom : 'Purchase Orders' : '/inventory/order-history')?.name}}
      </a>
      <div class="text-title-2 header">
        Purchase Order Details
      </div>
    </div>
  
    <div class="page-subheader">
      <div class="inventory-details" *ngIf="orderDetails?.wholesalerName">
        <div class="label">Wholesaler:</div>
        <div class="value">
          {{orderDetails.wholesalerName}}
        </div>
      </div>
      <div class="inventory-details" *ngIf="orderDetails?.csos">
        <div class="label">CSOS:</div>
        <div class="value">
          {{orderDetails.csos}}
        </div>
      </div>
      <div class="inventory-details" *ngIf="orderDetails?.purchaseOrder">
        <div class="label">PO #:</div>
        <div class="value">
          {{orderDetails?.purchaseOrder}}
        </div>
      </div>
      <div class="inventory-details" *ngIf="orderDetails?.invoiceNumber">
        <div class="label">Invoice #:</div>
        <div class="value">
          {{orderDetails?.invoiceNumber}}
        </div>
      </div>
      <div class="inventory-details" *ngIf="orderDetails?.shippedDate">
        <div class="label">Ship Date:</div>
        <div class="value">
          {{orderDetails.shippedDate | date}}
        </div>
      </div>
      <div class="inventory-details">
        <div class="label">NDCs Received:</div>
        <div class="value">
          {{orderDetails?.orderLineItems?.length}} NDC{{orderDetails?.orderLineItems?.length !== 1 ? 's' : ''}}
        </div>
      </div>
      <app-button *ngIf="!orderDetails?.processedDate" subStyle="white" text="Edit" [minWidth]="55"
        (clicked)="displayEditOrderDetailsDialog = true">
      </app-button>
    </div>
    <div class="inventory-details">
      <div class="label">Performed:</div>
      <div class="value">{{orderDetails?.receivedDate | formattedDate: 'MM d a, HH:mm'}}
      </div>
      <span class="vertical-divider"> | </span>
      <div class="label">Recorded:</div>
      <div class="value">
        {{orderDetails?.userFirstName}}
        <ng-container *ngIf="orderDetails?.userLastName && orderDetails?.userLastName[0]">
          {{orderDetails?.userLastName[0]}}.;
        </ng-container>
        {{orderDetails?.processedDate || orderDetails?.createDate | formattedDate: 'MM d a, HH:mm'}}
      </div>
    </div>
    <div #buyerSupplier>
      <app-supplier-buyer-sale-details class="block pt-3" *ngIf="orderDetails?.buyerDetails || orderDetails?.supplierDetails"
        [supplier]="orderDetails?.supplierDetails"
        [buyer]="orderDetails?.buyerDetails"
        [readOnly]="true"
        [takeDefaultSupplier]="false"
        [pharmacyIsSupplier]="false"
      >
      </app-supplier-buyer-sale-details>
    </div>
  </div>
<div #fileAttachment>
  <app-file-attachment 
    [files]="orderFiles$ | async"
    [fileTypes]="fileTypes"
    [requiresSignature]="true"
    [csosControl]="form.get('csos')"
    (downloadFile)="downloadFile($event)"
    (saveFiles)="saveAttachmentsList($event)"
  ></app-file-attachment>
</div>

  <div class="table-scroll-wrapper">
    <table class="table-primary inventory-history-table">
      <thead>
      <tr>
        <th (click)="sortByColumn('friendlyName')" class="text-left sort drug" scope="col">
          Drug
          <img [class.asc]="tableColumns.friendlyName" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
        </th>
        <th class="text-left" *ngIf="inventoryLocationsEnabled$ | async">Location</th>
        <th class="text-right on-hand" scope="col">On-hand</th>
        <th class="text-right receiving" scope="col">Receiving</th>
        <th class="text-right new-total" scope="col">New Total</th>
        <th class="text-right new-total" scope="col">SOH</th>
        <th class="text-right controls" scope="col">
          <!-- Controls -->
        </th>
      </tr>
      </thead>
      <tbody [ngStyle]="{'max-height': calculateMaxHeight()}">
      <tr class="table-row" *ngFor="let rowData of orderDetails?.orderLineItems; let i = index">
        <td class="text-left drug">
          <div class="heading">
            {{rowData.friendlyName}}
          </div>
          <div class="secondary">
            {{rowData.packageNdc}}
          </div>
        </td>
        <td class="text-left" *ngIf="inventoryLocationsEnabled$ | async">
          {{rowData?.locationName}}
        </td>
        <td class="text-right on-hand">
          {{rowData.onHand | number}}
        </td>
        <td class="text-right receiving">
          {{rowData.receiving | number}}
        </td>
        <td class="text-right new-total">
          {{rowData.total | number}}
        </td>
        <td class="text-right on-hand">
          {{rowData.sohEndingQty | number}}
        </td>
        <td class="text-right control">
          <!-- Empty for this table -->
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <!-- <div class="receive-drugs-container">
    <div class="label default">
      Received {{(orderDetails$ | async)?.orderLineItems?.length}} NDC{{(orderDetails$ | async)?.orderLineItems?.length !== 1 ? 's' : ''}}
    </div>
  </div> -->
</div>

<app-enter-pin-dialog [show]="pinDialog?.show"
                      (cancel)="closePinDialog()"
                      [focusPin]="focusPin"
                      (setPinHandler)="validateRequest($event)"
                      (handleResetPin)="openResetPinDialog()"
></app-enter-pin-dialog>

<app-reset-pin-dialog [show]="showResetPinDialog"
                      (cancel)="closeResetPinDialog()"
                      (afterUpdate)="afterPinUpdated($event)"
></app-reset-pin-dialog>

<app-order-details-dialog *ngIf="displayEditOrderDetailsDialog"
  [initialValue]="collectedOrderDetails"
  header="Edit Order Details"
  saveBtnText="Save"
  (canceled)="displayEditOrderDetailsDialog = false"
  (saved)="saveCollectedOrderDetails($event)">
</app-order-details-dialog>